import React, { useRef, useState } from "react";
import { motion } from "framer-motion";
import { PRICE_LABEL, startCheckout } from "@/lib/checkout";
import { T } from "@/constants/testIds";
import { Button } from "./ui/button";

/**
 * Clickable 3D ebook mockup.
 */
export default function Ebook3D({ compact = false }) {
  const ref = useRef(null);
  const [tilt, setTilt] = useState({ x: -15, y: 20 });

  const handleMove = (e) => {
    const r = ref.current?.getBoundingClientRect();
    if (!r) return;
    const cx = r.left + r.width / 2;
    const cy = r.top + r.height / 2;
    const dx = (e.clientX - cx) / r.width;
    const dy = (e.clientY - cy) / r.height;
    setTilt({ x: -15 + dy * -25, y: 20 + dx * 30 });
  };
  const reset = () => setTilt({ x: -15, y: 20 });

  return (
    <div
      ref={ref}
      className="relative ebook-3d select-none"
      onMouseMove={handleMove}
      onMouseLeave={reset}
    >
      <button
        type="button"
        data-testid={T.ebookMockup}
        onClick={startCheckout}
        aria-label={`Comprar ebook por ${PRICE_LABEL}`}
        className="group block mx-auto"
        style={{ width: compact ? 240 : 320, height: compact ? 340 : 460 }}
      >
        <div
          className="ebook-cover relative w-full h-full rounded-[2px] shadow-[0_40px_80px_-20px_rgba(220,38,38,0.4),0_30px_60px_-30px_rgba(0,0,0,0.9)]"
          style={{ transform: `rotateX(${tilt.x}deg) rotateY(${tilt.y}deg)` }}
        >
          <div className="spine" />
          <div className="pages" />
          <div className="face bg-[#0a0a0a] border border-white/10 overflow-hidden">
            {/* Cover art */}
            <div className="absolute inset-0 bg-gradient-to-br from-neutral-900 via-black to-red-950" />
            <div
              className="absolute inset-0 opacity-30"
              style={{
                backgroundImage:
                  "repeating-linear-gradient(90deg, rgba(255,255,255,0.06) 0px, rgba(255,255,255,0.06) 1px, transparent 1px, transparent 6px)",
              }}
            />
            <div className="absolute inset-0 flex flex-col justify-between p-6 text-left">
              <div>
                <div className="font-mono text-[9px] tracking-[0.3em] uppercase text-red-500 mb-2">
                  Arquivo · Vol. 01
                </div>
                <div className="h-[2px] w-10 bg-red-600" />
              </div>

              <div>
                <h3 className="font-display font-black leading-[0.95] text-neutral-50 text-3xl md:text-4xl">
                  LULA,
                  <br />
                  PT &<br />
                  <span className="text-red-600 italic">OS ESCÂNDALOS.</span>
                </h3>
                <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-500 mt-4">
                  Dossiê Brasil
                  <br />
                  Edição Documental
                </p>
              </div>

              <div className="flex items-end justify-between">
                <div className="font-mono text-[9px] tracking-[0.25em] text-neutral-600 uppercase">
                  2003 — 2021
                </div>
                <div className="h-10 w-10 cross-stamp opacity-70" />
              </div>
            </div>
            {/* top red tape */}
            <div className="absolute top-0 inset-x-0 h-2 bg-red-600" />
            <div className="absolute inset-0 pointer-events-none bg-gradient-to-br from-white/5 via-transparent to-black/70 opacity-80 group-hover:opacity-50 transition-opacity" />
          </div>
        </div>
      </button>

      <motion.div
        initial={{ opacity: 0, y: 10 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        className="text-center mt-10"
      >
        <Button
          data-testid={T.ebookBuyBtn}
          onClick={startCheckout}
          className="bg-red-600 hover:bg-red-700 text-white px-8 h-12 rounded-sm font-mono tracking-[0.25em] text-[12px] uppercase"
        >
          Comprar agora por {PRICE_LABEL}
        </Button>
        <p className="font-mono text-[10px] tracking-[0.2em] uppercase text-neutral-600 mt-4">
          Você será direcionado ao ambiente de pagamento Stripe
        </p>
      </motion.div>
    </div>
  );
}
